import ScreenNavigator from "../../../../../lib/html5-software-library/src/ranj/ui/ScreenNavigator";
import SkinFactory from "../../../core/ui/SkinFactory";
import LaptopNavigateEvent from "../model/LaptopNavigateEvent";
import { isNull } from "/lib/html5-software-library/src/ranj/util/TypeUtil";

export default class LaptopNavigateCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {ScreenNavigator} laptopScreenNavigator 
     */
    constructor(dispatcher, laptopScreenNavigator) {
        this._dispatcher = dispatcher;
        this._laptopScreenNavigator = laptopScreenNavigator;
    }

    execute(evt) {
        const navigateCommandEvent = evt.params.data;
        if (isNull(navigateCommandEvent.screen) && !isNull(navigateCommandEvent.screenType)) {
            navigateCommandEvent.screen = SkinFactory.getSkin(navigateCommandEvent.screenType);
        }

        const skin = navigateCommandEvent.screen;
        switch (evt.type) {
            case LaptopNavigateEvent.OPEN_SCREEN_REQUEST:
                this._laptopScreenNavigator.openScreen(skin, true, navigateCommandEvent.openUnderCurrent || false, navigateCommandEvent.animationType, navigateCommandEvent.animationOptions);
                break;
            case LaptopNavigateEvent.GOTO_SCREEN_REQUEST:
                this._laptopScreenNavigator.gotoScreen(skin, navigateCommandEvent.animationType, navigateCommandEvent.animationOptions);
                break;
            case LaptopNavigateEvent.CLOSE_SCREEN_REQUEST:
                this._laptopScreenNavigator.closeScreen(skin, navigateCommandEvent.animationType, navigateCommandEvent.animationOptions);
                break;
            case LaptopNavigateEvent.CLOSE_ALL_SCREENS_REQUEST:
                this._laptopScreenNavigator.closeAllScreens();
                break;
            case LaptopNavigateEvent.POP_UP_REQUEST:
                this._laptopScreenNavigator.openPopUp(skin, navigateCommandEvent.needsOverlay, navigateCommandEvent.priority, navigateCommandEvent.autoCenter, null, navigateCommandEvent.animationType, navigateCommandEvent.animationOptions);
                break;
            case LaptopNavigateEvent.CLOSE_POP_UP_REQUEST:
                this._laptopScreenNavigator.closePopUp(skin, navigateCommandEvent.animationType, navigateCommandEvent.animationOptions);
                break;
            default:
                console.info("[Laptop Navigate command] Unknown navigation command", evt.type, navigateCommandEvent);
                break;
        }

        console.info("[Laptop Navigate command] Navigate command executed ", evt.type, navigateCommandEvent);
    }
}